import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import axios from "axios";
import { CheckCircle2 } from "lucide-react";
import { SEO } from "../components/SEO";
import { API, LOGO_MARK } from "../lib/site";

const Unsubscribe = () => {
    const { search } = useLocation();
    const token = new URLSearchParams(search).get("token");
    const [state, setState] = useState(token ? "working" : "no-token");

    useEffect(() => {
        if (!token) return;
        axios
            .post(`${API}/newsletter/unsubscribe`, { token })
            .then(() => setState("done"))
            .catch(() => setState("done"));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <main>
            <SEO title="Unsubscribe | Global Green Hotel" description="Unsubscribe from Global Green Hotel updates." />
            <div className="grain flex min-h-screen items-center justify-center bg-[#04150D] px-5 py-32">
                <div className="w-full max-w-md rounded-2xl border border-white/10 bg-[#07211A] p-10 text-center">
                    <img src={LOGO_MARK} alt="Global Green Hotel logo" className="mx-auto w-36" />
                    {state === "working" && (
                        <p className="mt-8 text-sm text-[#FDFBF7]/60">Updating your subscription…</p>
                    )}
                    {state === "done" && (
                        <>
                            <CheckCircle2 size={40} className="mx-auto mt-8 text-[#D9B96A]" aria-hidden="true" />
                            <h1 className="font-display mt-5 text-2xl text-[#FDFBF7]" data-testid="unsubscribe-done">
                                You're unsubscribed
                            </h1>
                            <p className="mt-3 text-sm leading-relaxed text-[#FDFBF7]/60">
                                You will no longer receive newsletter updates from Global Green
                                Hotel. You can subscribe again anytime from our homepage.
                            </p>
                        </>
                    )}
                    {state === "no-token" && (
                        <>
                            <h1 className="font-display mt-8 text-2xl text-[#FDFBF7]">Unsubscribe</h1>
                            <p className="mt-3 text-sm leading-relaxed text-[#FDFBF7]/60">
                                To unsubscribe, use the one-click link included in any GGH email, or
                                contact us at{" "}
                                <a href="mailto:globalgreenhotel@gmail.com" className="font-bold text-[#D9B96A] hover:underline">
                                    globalgreenhotel@gmail.com
                                </a>
                                .
                            </p>
                        </>
                    )}
                    <Link to="/" data-testid="unsubscribe-home" className="btn-outline-light mt-8">
                        Back to Home
                    </Link>
                </div>
            </div>
        </main>
    );
};

export default Unsubscribe;
